import { defineExperiment } from '@cian/experiments/ab';

import { B2B_CPD_CONSULTATION } from 'shared/constants/experiments';

export const CpdConsultationExperiment = defineExperiment(B2B_CPD_CONSULTATION, {
  groups: ['A', 'B'] as const,
  default: 'A',
});
